export default {
  data () {
    return {
      mobile_flag: false
    }
  },
  methods: {
    isMobile () {
      var userAgentInfo = navigator.userAgent
      var mobileAgents = [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod'
      ]
      // 根据userAgent判断是否是手机
      for (let v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          this.mobile_flag = true
          break
        }
      }
    }
  },
  created () {
    this.isMobile()
  }
}



// WEBPACK FOOTER //
// ./src/mixi/adaption.js